/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayForwardIcon16Light = forwardRef('MediaUiAPlayForwardIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 2.5a.5.5 0 0 0-1 0v11a.5.5 0 0 0 1 0v-11Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.764 2.207A1.15 1.15 0 0 0 6 3.179v9.642a1.15 1.15 0 0 0 1.764.972l7.633-4.82a1.15 1.15 0 0 0 0-1.945L7.764 2.207ZM7 3.179c0-.118.13-.19.23-.127l7.633 4.821a.15.15 0 0 1 0 .254l-7.633 4.82a.15.15 0 0 1-.23-.126V3.179Z" })));
});
